//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from "react";
import styles from "./styles.module.scss";

const BillingTerms = () => {
  return (
    <div className={styles.container}>
      <div>
        <p className={styles.footnote}>Last Updated: January 23, 2026</p>
        <h1>Refund & Cancellation Policy</h1>
      </div>

      <div>
        <p>
          At FoodZee, we provide immediate access to digital content and
          personalized services. By making a purchase, you agree to the
          following terms regarding cancellations and refunds.
        </p>
      </div>

      <div>
        <b>1. Digital Reports & Bundles (One-time Purchase)</b>
        <p>
          The Ethnicity & Nutrition Report and AI DNA Report are digital
          products delivered via email or web access. All sales are final. Once
          the report is generated or sent, no refunds will be issued.
        </p>
      </div>

      <div>
        <b>2. FoodZee App Subscriptions</b>
        <p>
          <b>Cancellation:</b> You can cancel your subscription at any time
          through your Profile settings on our website (
          <a href="https://app.foodzee.tech" className={styles.grayText}>
            app.foodzee.tech
          </a>
          ) or by emailing us at{" "}
          <a href="mailto:support@foodzee.tech">support@foodzee.tech</a>.
        </p>

        <p>
          <b>Access after Cancellation:</b> Upon cancellation, you will retain
          access to the premium features until the end of your current paid
          billing period.
        </p>

        <p>
          <b>No Partial Refunds:</b> We do not offer prorated refunds for
          mid-month cancellations or for unused portions of a subscription
          period.
        </p>

        <p>
          <b>Paid Trials:</b> Any fees paid for trial periods are
          non-refundable.
        </p>
      </div>

      <div>
        <b>3. Refund Policy</b>
        <p>
          As we provide immediate access to digital services and content, we
          generally do not offer refunds. However, exceptions may be made at our
          sole discretion in the following limited cases:
        </p>
        <ul>
          <li>
            <b>Technical Failure:</b> If a confirmed technical error on our
            platform prevented you from accessing the service or receiving your
            report.
          </li>
          <li>
            <b>Duplicate Charges:</b> If you were accidentally charged twice due
            to a processing error.
          </li>
          <li>
            <b>Subscription Billing Errors:</b> If you were charged after a
            successfully confirmed cancellation (must provide proof of
            cancellation timestamp).
          </li>
        </ul>
      </div>

      <div>
        <b>4. Processing Requests</b>
        <ul>
          <li>
            Refund requests must be sent to{" "}
            <a href="mailto:support@foodzee.tech">support@foodzee.tech</a>{" "}
            within 14 days of the disputed transaction.
          </li>
          <li>Please include your email address and transaction ID.</li>
          <li>
            We will review and respond to your request within 5-10 business
            days.
          </li>
        </ul>
      </div>

      <div>
        <b>5. Chargebacks</b>
        <p>
          We encourage users to contact our support team directly via email{" "}
          <a href="mailto:support@foodzee.tech">support@foodzee.tech</a> to
          resolve any issues. We aim to provide fair resolutions to maintain a
          positive relationship with our customers.
        </p>
      </div>
    </div>
  );
};

export default BillingTerms;
